import React,{useState, useEffect} from 'react'
import {Link,useHistory} from 'react-router-dom'
import M from 'materialize-css'
import { API } from '../../api'
const Signup = () =>{
    const history =  useHistory()
    const [name,setName] = useState("")
    const [password,setPassword] = useState("")
    const [email,setEmail] = useState("")
    const [image,setImage] = useState("")
    const [url,setUrl] = useState(undefined)
    useEffect(()=>{
        uploadFields()
    },[url])

const uploadPic = ()=>{
        const data = new FormData()
        data.append("file",image)
        data.append("upload_preset","instagram_clone")
        data.append("cloud_name","dctq1stjk")
        fetch("	https://api.cloudinary.com/v1_1/dctq1stjk/image/upload/",{
            method:"post",
            body:data
        })
        .then(res=>res.json())
        .then(data=>{
            console.log(data)
            setUrl(data.url)
            console.log(data.url)
        })
        .catch(err=>{
            console.log(err)
    })
}
const uploadFields=()=>{
    fetch(`${API}/signup`,{
        method:"post",
        headers:{
            "Content-Type":"application/json"
        },
        body:JSON.stringify({
            name:name,
            password:password,
            email:email,
            photo:url
        })
    }).then(res=>
        res.json()
        )
    .then(data=>{
       if(data.error){
           M.toast({html:data.error,classes:"#b71c1c red darken-4"})
       }
       else{
           M.toast({html:data.message,classes:"#43a047 green darken-1"})
           history.push('/signin')
       }
    }).catch(err=>{
        console.log(err)
})
}
 const PostData = ()=>{
       if(image){
            uploadPic()
       }
       else{
            uploadFields()
       }
   
    }


    return(
        <div className="mycard">
            <div className="card auth-card input-field">
                <h2 className="brand-logo">Minsta</h2>
                <input className="brand-logo" type="text" placeholder="name" value={name} onChange={(e)=>setName(e.target.value)}></input>
                <input className="brand-logo" type="text" placeholder="email" value={email} onChange={(e)=>setEmail(e.target.value)}></input>
                <input className="brand-logo" type="password" placeholder="password" value={password} onChange={(e)=>setPassword(e.target.value)}></input>
                <div className="file-field input-field">
                    <div className="btn">
                        <span>Upload pic</span>
                        <input type="file" onChange={(e)=>setImage(e.target.files[0])}/>
                    </div>
                    <div className="file-path-wrapper">
                        <input className="file-path validate" type="text" placeholder="Image" />
                    </div>
                    </div>
                <button className="btn waves-effect waves-light brand-logo" onClick={()=>PostData()} >Signup
                 </button>
                 <h6 className="brand-logo"><Link to="/signin">Already have an Account?</Link></h6>
            </div>
        </div>
    )
}

export default Signup